import React from 'react';
import { BiTransfer } from 'react-icons/bi';
import { LiaStarSolid, LiaTimesSolid } from 'react-icons/lia';
import { MdAccountCircle } from 'react-icons/md';
import { formatRating, formatTimeStampToDate, getToken } from '../utils';

function OfferDetailsInModal({ content }) {
  const { offerDetails, handleOpenandCloseModal } = content;
  const userId = getToken()?.user?.id;

  return (
    <div className='flex flex-col w-full gap-8 h-full'>
      <div className='flex flex-col gap-4 w-full -pin'>
        <div className='flex flex-col gap-8 '>
          <div className='flex flex-row gap-2'>
            <span className='text-4xl text-b-mc/70 '>
              <MdAccountCircle />
            </span>
            <div className='flex flex-col '>
              <span>{offerDetails?.unique_code}</span>
              <div className='flex flex-row gap-4 items-center'>
                <p className='flex flex-row gap-2 items-center text-xs text-s-bk'>
                  Rating {Math.floor(formatRating(offerDetails?.user?.rating)) + 1}
                  <span className='text-green-500'>
                    <LiaStarSolid />
                  </span>
                </p>
                <p className='flex flex-row gap-2 items-center text-xs text-s-bk'>
                  Order Completed {offerDetails?.user?.trx_stats?.completed}
                  <span className='text-green-500'>{<BiTransfer />}</span>
                </p>
              </div>
            </div>
          </div>
          <span
            className='fixed items-center  top-6 right-6 text-2xl text-s-bk cursor-pointer hover:text-p-bk'
            onClick={() => handleOpenandCloseModal('close')}
          >
            <LiaTimesSolid />
          </span>
          <div className='text-p-bk flex flex-row justify-between'>
            <div className=' flex flex-col justify-between '>
              <p>{formatTimeStampToDate(offerDetails?.deadline)}</p>
              <span className='text-s-bk text-xs'>Transaction Time Limit</span>
            </div>
            <div className=' flex flex-col justify-between '>
              <p>{offerDetails?.transaction_method?.name}</p>
              <span className='text-s-bk  text-xs'>Transaction Method:</span>
            </div>
            <div className='flex flex-col justify-between'>
              <div className='flex flex-row gap-2 items-center'>
                <span>
                  {Number(offerDetails?.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{' '}
                  {offerDetails?.quote_currency?.symbol}
                </span>
                <img
                  className='w-5 h-[13px]'
                  src={offerDetails?.quote_currency?.country?.flag}
                  alt='ccurrency flag'
                />
              </div>

              <span className='text-s-bk text-xs'>Available Amount</span>
            </div>
          </div>

          <div className='flex flex-col gap'>
            {/* <span className="text-s-bk text-xs">Instruction </span>{" "} */}
            <p>
              {' '}
              <small className='border-x-[2px] mb-8 text-[10px] mr-2 border-b-mc rounded text-p-bk/0' />
              {offerDetails?.remark === '1'
                ? 'Urgent'
                : 'Fast Transaction ASAP'}
            </p>
          </div>
        </div>{' '}
        <div className='text-s-bk flex flex-col gap-1 border-dashed px-4 bg-b-mct border-y-t-bk border-y-hf py-2'>
          <div className='text-s-bk flex flex-row justify-between'>
            <p>Rate</p>{' '}
            <span className='text-p-bk'>
              {Number(offerDetails?.rate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{' '}
              {offerDetails?.base_currency?.symbol}
            </span>
          </div>
          <div className='text-s-bk flex flex-row justify-between'>
            <p>Transacion fee</p> <span className='text-p-bk'>{Number(offerDetails?.auth_user_commission
).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{' '}
              {offerDetails?.base_currency?.symbol}</span>
          </div>
          {offerDetails?.discount === null ? null : (
            <div className='text-s-bk flex flex-row justify-between'>
              <p>Discount</p>{' '}
              <span className='text-p-bk'>{offerDetails?.discount}</span>
            </div>
          )}
          <div className='text-s-bk flex flex-row justify-between'>
            <p>Subtotal Amount</p>{' '}
            <span className='text-p-bk'>
              {Number(offerDetails?.rate * offerDetails?.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{' '}
              {offerDetails?.base_currency?.symbol}
            </span>
          </div>
          <div className='text-s-bk flex flex-row justify-between'>
            <p>Total Amount</p>{' '}
            <span className='text-p-bk'>
              {Number((offerDetails?.rate * offerDetails?.amount) + offerDetails?.auth_user_commission).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{' '}
              {offerDetails?.base_currency?.symbol}
            </span>
          </div>
        </div>
      </div>

      {offerDetails?.originator?.id !== userId && (
        <button
          type='button'
          className={`text-p-wh px-6   py-2.5 font-semibold  rounded ${
            offerDetails?.transaction_type?.id === 1
              ? 'bg-green-500 hover:bg-green-300 focus:bg-green-400'
              : offerDetails?.transaction_type?.id === 2
              ? 'bg-red-500 hover:bg-red-300 focus:bg-red-400'
              : null
          }`}
          onClick={() => handleOpenandCloseModal('accept')}
        >
          {offerDetails?.transaction_type?.id === 1
            ? 'Buy'
            : offerDetails?.transaction_type?.id === 2
            ? 'Sell'
            : null}
        </button>
      )}
    </div>
  );
}

export default OfferDetailsInModal;
